import loadJS from '../../lib-js/dom/network/load-js';

import {withDwUtils} from './dw-utils';

function plugin(embedElement) {
	const data = JSON.parse(embedElement.getAttribute('data-neonaut-tosc5'));
	const {
		tagId,
		scriptUrl,
		settings,
		scrollOffset,
		dateFrom,
		dateTo,
		occupancy,
	} = data;

	function loadTag() {
		dw('settings', tagId, settings);
		loadJS(scriptUrl);
	}

	withDwUtils(() => {
		if (scrollOffset) {
			dw('onGetAppContainerOffset', tagId, () => scrollOffset);
		}

		const isInitial =
			!location.hash ||
			location.hash === '#' ||
			location.hash === '#/' ||
			location.hash === '#/unterkuenfte';
		if (isInitial && (dateFrom || dateTo || occupancy)) {
			const quickFind = {};
			quickFind.dateFrom = new Date(dateFrom);
			quickFind.dateTo = new Date(dateTo);
			quickFind.occupancy1 = occupancy ?? {
				units: 1,
				adults: 2,
				children: [],
			};

			dw.accommodationQuickFind(
				settings.localStorageId,
				quickFind,
				loadTag
			);
		} else {
			loadTag();
		}
	});
}

export function render() {
	document.querySelectorAll('.js-neonaut-tosc5').forEach(plugin);
}
